// extracted by mini-css-extract-plugin
export var container = "_7p-0";
export var containerTopRight = "_7p-1";